export const page3 = {
  "name": "page3",
  "elements": [
    {
      "type": "text",
      "name": "weight",
      "isRequired": true,
      "title": "How much do you weight? (kg)",
      "inputType": "number",
      "min": 10,
      "max": 250
    },
    {
      "type": "text",
      "name": "height",
      "isRequired": true,
      "title": "What is Your height? (cm)",
      "inputType": "number",
      "min": 50,
      "max": 250
    }
  ]
};